import gql from 'graphql-tag';

import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment ProductDataFragment on ProductData {
    # sourced from both gen-products AND product-listings
    name
    description
    url
    humanReadableId
    imageUrl

    # sourced from gen-products
    id
    image {
      ...ImageDataFragment
    }
    price
    salePrice
    retailerName
    tags {
      name
      slug
    }

    # sourced from product-listings
    originalPrice
    currentPrice
    retailer
  }
  ${ImageDataFragment}
`;
